module.exports = __webpack_public_path__ + "img/9blue.771279f9.png";